import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Filters.css';

import FiltersPanel from './ListFilterContainer'; //V1 - FiltersPanel
import ButtonFilters from './ButtonFilters';

function Filters({ idPlaylist, filters, onValid, onClear, height = `100%`, style, panelStyle }) {
  const [ showFilters, setShowFilters ] = useState(false);
  const onClose = () => setShowFilters(false);
  const showFiltersPanel = () => setShowFilters(!showFilters);
  const isClear = true; // filters.every( x => (x.value === ``) );

  useEffect(() => {
    setShowFilters(false);
    onClear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idPlaylist])

  return (
    <>
      <ButtonFilters className={`basic`} active={showFilters} onClick={showFiltersPanel} onClear={onClear} showClear={!isClear} style={style} />
      <FiltersPanel active={showFilters} filters={filters} onValid={onValid} height={height} onClose={onClose} style={panelStyle} />
    </>
  );
}

Filters.propTypes = {
  filters: PropTypes.array,
  onValid: PropTypes.func,
  onClear: PropTypes.func.isRequired,
  height: PropTypes.any,
  style: PropTypes.object,
  panelStyle: PropTypes.object
}

export default Filters;
